"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.IntlContextProvider = exports.IntlContextConsumer = exports.IntlContext = void 0;
var _react = _interopRequireDefault(require("react"));
var IntlContext = exports.IntlContext = /*#__PURE__*/_react.default.createContext();
var IntlContextProvider = exports.IntlContextProvider = IntlContext.Provider;
var IntlContextConsumer = exports.IntlContextConsumer = IntlContext.Consumer;